<template>
  <div class="main-page">
    <div class="topbar">
      <div class="topbar-logo">
        <img src="../assets/img/logo.png" />
        <span>{{ $t('menu.h1') }}</span>
        <!-- <em>{{ $t('menu.h2') }}</em> -->
      </div>
      <div class="topbar-link">
        <router-link to="/Profile"><span class="topbar-username"><i class="el-icon-user-solid"></i> {{ username }}</span></router-link>
        <a class="el-link el-link--default" href="javascript:;" @click="onLogout()">{{$t('menu.signout')}}</a>
      </div>
    </div><!--topbar-->
    <div class="sidebar">
      <ul>
        <li><router-link to="/Home">{{$t('menu.m01')}}</router-link></li>
        <li>
          <span>{{$t('menu.m02')}}</span>
          <ul>
            <li class="sidemenuicon sidemenu01"><router-link to="/CodeList">{{$t('menu.m03')}}</router-link></li>
            <li class="sidemenuicon sidemenu02"><router-link to="/SubscribedCodes">{{$t('menu.m04')}}</router-link></li>
          </ul>
        </li>
        <li>
          <span>{{$t('menu.m05')}}</span>
          <ul>
            <li class="sidemenuicon sidemenu03"><router-link to="/SingleCodeAnalysis">{{$t('menu.m06')}}</router-link></li>
            <li class="sidemenuicon sidemenu04"><router-link to="/ComparisonAnalysis">{{$t('menu.m07')}}</router-link></li>
            <li class="sidemenuicon sidemenu05"><router-link to="/CombinationAnalysis">{{$t('menu.m08')}}</router-link></li>
          </ul>
        </li>
        <li>
          <span>{{$t('menu.m09')}}</span>
          <ul>
            <li class="sidemenuicon sidemenu06"><router-link to="/FreeReport">{{$t('menu.m10')}}</router-link></li>
            <li class="sidemenuicon sidemenu07"><router-link to="/PaidReport">{{$t('menu.m11')}}</router-link></li>
            <li class="sidemenuicon sidemenu08"><router-link to="/DownloadRawdata">{{$t('menu.m12')}}</router-link></li>
          </ul>
        </li>
        <li>
          <span>{{$t('menu.m13')}}</span>
          <ul>
            <li class="sidemenuicon sidemenu09"><router-link to="/CustomizedStudy">{{$t('menu.m14')}}</router-link></li>
            <li class="sidemenuicon sidemenu10"><router-link to="/LookForChinaCustomers">{{$t('menu.m15')}}</router-link></li>
            <li class="sidemenuicon sidemenu11"><router-link to="/LookForSuppliers">{{$t('menu.m16')}}</router-link></li>
          </ul>
        </li>
        <li>
          <span>{{$t('menu.m17')}}</span>
          <ul>
            <li class="sidemenuicon sidemenu12"><router-link to="/Profile">{{$t('menu.m18')}}</router-link></li>
          </ul>
        </li>
      </ul>
    </div><!--sidebar-->
    <div class="main-content">
      <router-view></router-view>
    </div><!--main-content-->
  </div>
</template>

<script>
export default {
  data(){
    return{
      username : ''
    }
  },
  mounted(){
    if(!this.getLocalStorage('token')){
      this.$router.push({ path: "/" })
    }
    if(!this.getLocalStorage('userinfo')){
      this.getUserInfo()
    }
  },
  methods: {
    onLogout: function(){
      console.log('Logout');
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/user/info?key='+that.getLocalStorage('key')+'&token='+that.getLocalStorage('token')+'&lang='+that.getLang()
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(data) {
          console.log(data)
          if(data.code === 200){
            localStorage.removeItem("key")
            localStorage.removeItem("token")
            localStorage.removeItem("userinfo")
            that.$router.push({ path: "/Login" });
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
      //
    },

    /**
     * 获取用户资料
     */
    getUserInfo: function(){
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/user/info?key='+that.getLocalStorage('key')+'&token='+that.getLocalStorage('token')+'&lan=cn';
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log('--getUserInfo', rex)
          that.username = rex.data.info.first_name + ' ' + rex.data.info.last_name
        },
        error: function(response) {
          console.log(response)
        }
      })

    },
  }
}
</script>